import { JSX } from 'react'




export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	return (
		<></>

	)

}
